import * as React from 'react';
import classnames from 'classnames';

import MetricsChannelsBasicSingleEntry from './MetricsChannelsBasicSingleEntry';

import { isDefined } from 'utils/helper/common';

import './metrics-channels-basic.scss';

import type { ChannelTypes } from 'types';
import type {
  MetricsChannelsBasicItem,
  MetricsChannelsBasicLayout,
  MetricsChannelsBasicType
} from './types';

type Props = {
  channels: Array<MetricsChannelsBasicItem>,
  showChannels?: Array<ChannelTypes>,
  type?: MetricsChannelsBasicType,
  layout?: MetricsChannelsBasicLayout,
  maxChannels?: number,
  includeRatio?: boolean,
  hideIconPopover?: boolean
};

class MetricsChannelsBasic extends React.PureComponent<Props> {
  static defaultProps = {
    type: 'standard',
    layout: 'inline',
    includeRatio: false
  };

  render(): React.ReactNode {
    const {
      type,
      layout,
      channels,
      maxChannels,
      showChannels,
      includeRatio,
      hideIconPopover
    } = this.props;

    const containerClasses = classnames('metrics-channels-basic', {
      [`metrics-channels-basic--layout-${String(layout)}`]: Boolean(layout)
    });
    const children = channels
      .map((item) => (
        <MetricsChannelsBasicSingleEntry
          key={item.type}
          item={item}
          showChannels={showChannels}
          type={type}
          layout={layout}
          includeRatio={includeRatio}
          hideIconPopover={hideIconPopover}
        />
      ))
      .filter(isDefined);

    return (
      <div className={containerClasses}>
        {
          maxChannels
            ? children.slice(0, maxChannels)
            : children
        }
      </div>
    );
  }
}

export default MetricsChannelsBasic;
